"use strict";

require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.number.is-integer");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.date.to-string");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Body_1 = require("Core/Body");
var Currencies_1 = require("Core/Currencies");
var Notifications_1 = require("Core/Notifications");
var Validation_1 = require("Components/Validation/Validation");
exports.ValidationModule = Validation_1.ValidationModule;
var CartService_1 = require("Components/Cart/CartService");
var Step1Selectors_1 = require("Components/Cart/Step1/Step1Selectors");
var Step2_1 = require("Components/Cart/Step2/Step2");
exports.Step2Component = Step2_1.Step2Component;
var Step3_1 = require("Components/Cart/Step3");
exports.Step3Component = Step3_1.Step3Component;
var CartShowMoreBtn_1 = require("Components/Cart/CartShowMoreBtn");
exports.CartShowMoreBtn = CartShowMoreBtn_1.CartShowMoreBtn;
var GuestModal_1 = require("Components/Cart/GuestModal");
exports.GuestModal = GuestModal_1.GuestModal;
var decimal_js_1 = require("decimal.js");
exports.CartOfferModule = function () {
  var FORM = Step1Selectors_1.Step1Selectors.FORM,
    OFFER = Step1Selectors_1.Step1Selectors.OFFER,
    SUMMARY_PANEL = Step1Selectors_1.Step1Selectors.SUMMARY_PANEL;
  var Selector = {
    CART_ICON: {
      COUNT: "#offer-count",
      VALUE: "#offerValue"
    },
    PRODUCT_TILE: {
      ADD_ITEM: ".js_product_tile_add_to_offer"
    },
    PRODUCT_PAGE: {
      ADD_ITEM: ".js_product_page_add_to_offer",
      OFFER_QUANTITY: ".js_product_offer_quantity "
    },
    CATEGORY_PAGE: {
      ADD_ITEM: '.js_category_page_add_to_offer'
    },
    COMMON: {
      REMOVE_ITEM: ".js_remove_from_cart"
    },
    CART: {
      EMPTY_INFO: "#cart_empty",
      DELIVERY_TIME: '#DeliveryTime',
      STEP_3: {
        FORM: '#step3_form_offer'
      }
    },
    MODAL: '#cart-modal'
  };
  var OFFER_COUNT_LIMIT = 50;
  var Message = {
    MAX_OFFER_PRODUCT_LIMIT: "Wybrano największą możliwą ilość produktu",
    OFFER_COUNT_LIMIT: "W kalkulacji możesz mieć maksymalnie " + OFFER_COUNT_LIMIT + " różnych elementów. Ilość jaką próbujesz dodać do kalkulacji przekracza limit."
  };
  var url = window.location.toString();
  var lang = url.split('/')[3];
  function calcTotalQuantities() {
    var totalQuantity = new decimal_js_1.Decimal(0);
    $(OFFER.OFFER_QUANTITY).each(function () {
      var tempQuantity;
      var unit = new decimal_js_1.Decimal(parseFloat($(this).attr('data-input-step')));
      console.log(unit.e);
      if (unit.e == 0) {
        tempQuantity = new decimal_js_1.Decimal($(this).val());
      } else {
        tempQuantity = new decimal_js_1.Decimal(1);
      }
      if (tempQuantity.isNaN()) {
        tempQuantity = new decimal_js_1.Decimal(1);
      }
      totalQuantity = totalQuantity.plus(tempQuantity);
    });
    $(SUMMARY_PANEL.TOTAL_QUANTITIES).text(totalQuantity.toString());
  }
  function calcTotalPrice() {
    var total = 0;
    $(OFFER.OFFER_TOTAL).each(function () {
      var totalSinglePrice = $(this).attr('data-total-price');
      total += parseFloat(totalSinglePrice);
    });
    $(SUMMARY_PANEL.TOTAL).text(Currencies_1.formatCurrency(total));
  }
  function executeTotalCalculations() {
    calcTotalQuantities();
    calcTotalPrice();
  }
  function cartChangeHandler(res) {
    if (res.result) {
      if (res.value.count > 0) {
        $(Selector.CART_ICON.COUNT).show().html(res.value.count.toString());
      } else {
        $(Selector.CART_ICON.COUNT).hide().html('0');
        $(Selector.CART.EMPTY_INFO).show(250);
        $(FORM).hide(250);
      }
      $(Selector.CART_ICON.VALUE).html(res.value.total.toString());
      Notifications_1.Notifications.add(res.msg, res.type ? res.type : "offer");
    } else {}
  }
  function extractCommonData() {
    var $this = $(this);
    var productId = $this.data('product-id');
    return {
      $this: $this,
      productId: productId
    };
  }
  function ProdTileAddToCart() {
    var productId = extractCommonData.call(this).productId;
    var itGoesBeyondCountLimit = checkIfAddedProductGoesBeyondCountLimit(1);
    if (itGoesBeyondCountLimit) {
      Notifications_1.Notifications.add(Message.OFFER_COUNT_LIMIT, "warning");
    } else {
      CartService_1.CartService.add(lang, productId, 1).done(cartChangeHandler);
    }
  }
  function ProdPageAddToCart() {
    var productId = extractCommonData.call(this).productId;
    var quantity = $(OFFER.OFFER_QUANTITY).val() || 1;
    var itGoesBeyondCountLimit = checkIfAddedProductGoesBeyondCountLimit(quantity);
    if (itGoesBeyondCountLimit) {
      Notifications_1.Notifications.add(Message.OFFER_COUNT_LIMIT, "warning");
    } else {
      CartService_1.CartService.add(lang, productId, quantity).done(cartChangeHandler);
    }
  }
  function RemoveFromCart() {
    var _a = extractCommonData.call(this),
      $this = _a.$this,
      productId = _a.productId;
    $(this).attr('disabled', 'disabled');
    CartService_1.CartService.remove(lang, productId).done(cartChangeHandler).then(function () {
      return updateDeliveryTime();
    }).then(function () {
      return $this.closest(OFFER.OFFER_CONTAINER).remove();
    }).then(function () {
      return executeTotalCalculations();
    });
  }
  function ClearAllProductsFromCart() {
    CartService_1.CartService.clear_offer(lang).done(cartChangeHandler).then(function () {
      return updateDeliveryTime();
    }).then(function () {
      return $(Selector.CART.EMPTY_INFO).show(250);
    }).then(function () {
      return $(FORM).hide(250);
    });
    $(Selector.CART_ICON.COUNT).hide().html('0');
  }
  function IncreaseOfferProdQuantity() {
    var _a = extractCommonData.call(this),
      $this = _a.$this,
      productId = _a.productId;
    var $input = $(this).next('input');
    var row = $(this).closest(OFFER.OFFER_CONTAINER);
    var price = row.data('product-price');
    var $total = row.find(OFFER.OFFER_TOTAL);
    var quantity = new decimal_js_1.Decimal($input.val());
    var max = new decimal_js_1.Decimal($input.attr('max'));
    var data_input_step = parseFloat($input.attr('data-input-step'));
    var unit_is_float;
    if (Number.isInteger(data_input_step)) {
      unit_is_float = 0;
    } else {
      unit_is_float = 2;
    }
    if (quantity.greaterThanOrEqualTo(max)) {
      Notifications_1.Notifications.add(Message.MAX_OFFER_PRODUCT_LIMIT, "info");
      return false;
    } else {
      var step = $input.data('input-step');
      quantity = quantity.plus(step);
      $input.val(quantity.toFixed(unit_is_float));
      $total.text(Currencies_1.formatCurrency(price * quantity.toNumber()));
      $total.attr('data-total-price', price * quantity.toNumber());
      row.find('button').attr('disabled', 'disabled');
      CartService_1.CartService.update(productId, quantity.toNumber()).done(function ($result) {
        $input.val(quantity.toFixed(unit_is_float));
        $total.text(Currencies_1.formatCurrency(price * quantity.toNumber()));
        $total.attr('data-total-price', price * quantity.toNumber());
        row.find('button').removeAttr('disabled');
        if ($result.msg != undefined && $result.msg != null) {
          Notifications_1.Notifications.add($result.msg, "warning");
        }
      });
    }
  }
  function DecreaseOfferProdQuantity() {
    var _a = extractCommonData.call(this),
      $this = _a.$this,
      productId = _a.productId;
    var $input = $(this).prev('input');
    var row = $(this).closest(OFFER.OFFER_CONTAINER);
    var price = row.data('product-price');
    var $total = row.find(OFFER.OFFER_TOTAL);
    var quantity = new decimal_js_1.Decimal($input.val());
    var min = new decimal_js_1.Decimal($input.attr('min'));
    var data_input_step = parseFloat($input.attr('data-input-step'));
    var unit_is_float;
    if (Number.isInteger(data_input_step)) {
      unit_is_float = 0;
    } else {
      unit_is_float = 2;
    }
    if (quantity.lessThanOrEqualTo(min)) {
      return false;
    } else {
      var step = $input.data('input-step');
      quantity = quantity.minus(step);
      $input.val(quantity.toString());
      $total.text(Currencies_1.formatCurrency(price * quantity.toNumber()));
      $total.attr('data-total-price', price * quantity.toNumber());
      row.find('button').attr('disabled', 'disabled');
      CartService_1.CartService.update(productId, quantity.toNumber()).done(function ($result) {
        $input.val(quantity.toFixed(unit_is_float));
        $total.text(Currencies_1.formatCurrency(price * quantity.toNumber()));
        $total.attr('data-total-price', price * quantity.toNumber());
        row.find('button').removeAttr('disabled');
        if ($result.msg != undefined && $result.msg != null) {
          Notifications_1.Notifications.add($result.msg, "warning");
        }
      });
    }
  }
  function InputFocusHandler(event) {
    var _a = extractCommonData.call(this),
      $this = _a.$this,
      productId = _a.productId;
    var row = $(this).closest(OFFER.OFFER_CONTAINER);
    var $total = row.find(OFFER.OFFER_TOTAL);
    var price = row.data('product-price');
    var quantity = new decimal_js_1.Decimal($this.val());
    var max = new decimal_js_1.Decimal($this.attr('max'));
    if (quantity.greaterThanOrEqualTo(max)) {
      Notifications_1.Notifications.add(Message.MAX_OFFER_PRODUCT_LIMIT, "info");
      $this.val($this.attr('max'));
    } else {
      $total.text(Currencies_1.formatCurrency(price * quantity.toNumber()));
      $total.attr('data-total-price', price * quantity.toNumber());
      CartService_1.CartService.update(productId, quantity.toNumber()).done(function ($result) {
        $this.val(quantity.toFixed(2));
        $total.text(Currencies_1.formatCurrency(price * quantity.toNumber()));
        $total.attr('data-total-price', price * quantity.toNumber());
        if ($result.msg != undefined && $result.msg != null) {
          Notifications_1.Notifications.add($result.msg, "warning");
        }
      });
    }
  }
  function InputKeyupHandler(event) {
    var _a = extractCommonData.call(this),
      $this = _a.$this,
      productId = _a.productId;
    var maxQuantity = parseFloat($this.attr('max'));
    var minQuantity = parseFloat($this.attr('min'));
    var quantity = parseFloat($this.val());
    var row = $(this).closest(OFFER.OFFER_CONTAINER);
    var price = row.data('product-price');
    var $total = row.find(OFFER.OFFER_TOTAL);
    if (event.keyCode == 13) {
      return false;
    }
    if (isNaN(quantity)) {
      quantity = 1;
    }
    if (quantity >= maxQuantity) {
      Notifications_1.Notifications.add(Message.MAX_OFFER_PRODUCT_LIMIT, "info");
      quantity = maxQuantity;
      $this.val(quantity);
    } else if (quantity <= minQuantity) {
      quantity = minQuantity;
    }
    $total.text(Currencies_1.formatCurrency(price * quantity));
    $total.attr('data-total-price', price * quantity);
  }
  function InputFocusoutHandler(event) {
    var _a = extractCommonData.call(this),
      $this = _a.$this,
      productId = _a.productId;
    var quantity = parseFloat($this.val());
    if (isNaN(quantity)) {
      quantity = 1;
    }
    $this.val(quantity);
  }
  function updateDeliveryTime() {
    CartService_1.CartService.getDeliveryTime().done(function (msg) {
      $(Selector.CART.DELIVERY_TIME).toggle(!!msg).html(msg);
    });
  }
  function checkIfAddedProductGoesBeyondCountLimit(qty) {
    return parseInt($(Selector.CART_ICON.COUNT).text()) + qty > OFFER_COUNT_LIMIT;
  }
  $(Selector.CART.STEP_3.FORM).validate({
    rules: {
      agree_rules: 'required',
      agree_data: 'required',
      agree_delivery: 'required'
    }
  });
  Body_1.$body.on("click", Selector.PRODUCT_TILE.ADD_ITEM, ProdTileAddToCart);
  Body_1.$body.on("click", Selector.CATEGORY_PAGE.ADD_ITEM, ProdPageAddToCart);
  Body_1.$body.on("click", Selector.PRODUCT_PAGE.ADD_ITEM, ProdPageAddToCart);
  Body_1.$body.on("click", OFFER.OFFER_CLEAR_ALL, ClearAllProductsFromCart);
  Body_1.$body.on("click", OFFER.OFFER_REMOVE, RemoveFromCart);
  Body_1.$body.on("keyup", OFFER.OFFER_QUANTITY, InputKeyupHandler);
  Body_1.$body.on("keyup", OFFER.OFFER_QUANTITY, executeTotalCalculations);
  Body_1.$body.on("focusout", OFFER.OFFER_QUANTITY, InputFocusoutHandler);
  Body_1.$body.on("click", OFFER.OFFER_QUANTITY_CONTROL_INCREASE, IncreaseOfferProdQuantity);
  Body_1.$body.on("click", OFFER.OFFER_QUANTITY_CONTROL_DECREASE, DecreaseOfferProdQuantity);
  Body_1.$body.on('click', OFFER.OFFER_QUANTITY_CONTROL_INCREASE, executeTotalCalculations);
  Body_1.$body.on('click', OFFER.OFFER_QUANTITY_CONTROL_DECREASE, executeTotalCalculations);
  Body_1.$body.on("blur", OFFER.OFFER_QUANTITY, InputFocusHandler);
}();